import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { opinions } from '../data/content';
export function Opinions() {
  return <section className="w-full bg-cream px-5 pb-24 sm:pb-32" data-id="element-141" data-mp="1yiy2dcjad3iy">
      <div className="mx-auto w-full max-w-[1120px]" data-id="element-142" data-mp="1kongr42l5ph4">
        <Reveal data-id="element-143" data-mp="1or0jdjm1d79o">
          <p className="text-center text-[11px] font-bold uppercase tracking-[0.22em] text-muted" data-id="element-144" data-mp="1oqiksgbwigyl">
            Det siger trænerne
          </p>
        </Reveal>

        <Reveal delay={0.06} data-id="element-145" data-mp="1atlt6cnykvgn">
          <h2 className="mx-auto mt-6 max-w-3xl text-center font-display text-4xl font-bold uppercase leading-[1] tracking-tight text-navy sm:text-5xl" data-id="element-146" data-mp="1fqvfhjg1wr09">
            Trænere, der allerede har{' '}
            <span className="font-serif text-[0.9em] normal-case italic text-red" data-id="element-147" data-mp="15rmo8ycklqhl">
              sæsonen på plads
            </span>
          </h2>
        </Reveal>

        <ul className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-148" data-mp="2w2hhmdsu0qc9">
          {opinions.map((opinion, index) => <Reveal as="li" key={opinion.name} delay={index % 3 * 0.06} data-id="element-149" data-mp="15qmekf2fl1da" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-card border border-line bg-white p-7 shadow-card" data-id="element-150" data-mp="15oje113njpub">
                <QuoteIcon className="h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-151" data-mp="10povm09lk3aq" />

                <blockquote className="mt-4 text-base leading-relaxed text-ink" data-id="element-152" data-mp="1fiihq4jdjhod">
                  {opinion.quote}
                </blockquote>

                <figcaption className="mt-auto border-t border-line pt-4" data-id="element-153" data-mp="mqyr3zkg71cc">
                  <span className="block font-display text-lg font-bold uppercase tracking-wide text-navy" data-id="element-154" data-mp="hsx6vbbacvza">
                    {opinion.name}
                  </span>
                  <span className="block text-sm text-muted" data-id="element-155" data-mp="wnv0s8m31tih">{opinion.role}</span>
                </figcaption>
              </figure>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}